"use strict";

(function () {
  Turbolinks.start();

  var ready = function ready() {
    console.log("🦄 TurboLinks Ready -> " + window.location.href + " width: " + $(window).width()); // We reset the scroll to 0 at every page load

    $('html, body').scrollTop(0);

    if ($(window).width() >= 481) {
      setAnimationList();
      $('.slider').bxSlider({
        auto: false,
        autoHover: true,
        controls: true,
        pager: false,
        touchEnabled: false
      });
    } // VIDEO 16_9


    $("iframe").resize16_9();
    $(".sub-vid").resize16_9();
    $(".16-9").resize16_9(); // VIDEO 16_9 END

    $(".menu-mobile").bkoMenu();
    $("body").bkoCookies(); // Galerie images réalisation

    var img_index = 0;
    $(".img-realisation, .img-produitpro, .img-produit").click(function () {
      $('.modal-realisation img, .modal-produitpro img, .modal-produit img').attr('src', $(this).attr('src'));
      $('.modal-realisation, .modal-produitpro, .modal-produit').fadeIn();
      $('html').css('overflow-y', 'hidden');
      img_index = $(this).data('img-index');
    });
    $(".modal-realisation img, .modal-produitpro img, .modal-produit img, .previous-img, .next-img").click(function (e) {
      e.stopPropagation();
    });
    $('.modal-realisation, .modal-produitpro, .modal-produit').click(function (e) {
      $(this).fadeOut();
      $('html').css('overflow-y', 'auto');
    }); // Slider video

    $('.slide-video').click(function (e) {
      e.preventDefault();
      $('.slider-video-content').addClass('show');
    });
    $('.slider-video-content .close').click(function () {
      $('.slider-video-content').removeClass('show');
    });
    var actualImg = 0;
    var previousImg = -1;
    var previousImgUrl = $("input[data-img='" + previousImg + "']").val();
    var nextImg = 1;
    var nextImgUrl = $("input[data-img='" + nextImg + "']").val();
    var actualTxt = 0;
    var previousTxt = -1;
    var previousTxtContent = $("input[data-txt='" + previousTxt + "']").val();
    var nextTxt = 1;
    var nextTxtContent = $("input[data-txt='" + nextTxt + "']").val();
    $('.previous-img').click(function () {
      if (previousImgUrl != null) {
        $('.modal-produit img').attr('src', previousImgUrl);
        nextImg = actualImg;
        actualImg--;
        previousImg--;
        previousImgUrl = $("input[data-img='" + previousImg + "']").val();
        nextImgUrl = $("input[data-img='" + nextImg + "']").val();
        $('.modal-produit .gallery-txt').html(previousTxtContent);
        nextTxt = actualTxt;
        actualTxt--;
        previousTxt--;
        previousTxtContent = $("input[data-txt='" + previousTxt + "']").val();
        nextTxtContent = $("input[data-txt='" + nextTxt + "']").val();
      }
    });
    $('.next-img').click(function () {
      if (nextImgUrl != null) {
        $('.modal-produit img').attr('src', nextImgUrl);
        previousImg = actualImg;
        actualImg++;
        nextImg++;
        previousImgUrl = $("input[data-img='" + previousImg + "']").val();
        nextImgUrl = $("input[data-img='" + nextImg + "']").val();
        $('.modal-produit .gallery-txt').html(nextTxtContent);
        previousTxt = actualTxt;
        actualTxt++;
        nextTxt++;
        previousTxtContent = $("input[data-txt='" + previousTxt + "']").val();
        nextTxtContent = $("input[data-txt='" + nextTxt + "']").val();
        console.log(nextTxtContent);
      }
    });
    var bulkLazyload = new BulkLazyload();
    bulkLazyload.init();
    $('#catalogue_pro').DataTable({
      language: {
        processing: "Traitement en cours...",
        search: "Rechercher&nbsp;:",
        lengthMenu: "Afficher _MENU_ &eacute;l&eacute;ments",
        info: "Affichage de l'&eacute;lement _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
        infoEmpty: "Affichage de l'&eacute;lement 0 &agrave; 0 sur 0 &eacute;l&eacute;ments",
        infoFiltered: "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
        infoPostFix: "",
        loadingRecords: "Chargement en cours...",
        zeroRecords: "Aucun &eacute;l&eacute;ment &agrave; afficher",
        emptyTable: "Aucune donnée disponible dans le tableau",
        paginate: {
          first: "Premier",
          previous: "Pr&eacute;c&eacute;dent",
          next: "Suivant",
          last: "Dernier"
        },
        aria: {
          sortAscending: ": activer pour trier la colonne par ordre croissant",
          sortDescending: ": activer pour trier la colonne par ordre décroissant"
        }
      },
      order: [[0, "desc"]]
    });
  };

  var cache = function cache() {
    console.log("🦄 TurboLinks CacheLoad");
    resetAnimationList();
  };

  document.addEventListener("turbolinks:before-cache", cache);
  document.addEventListener("turbolinks:load", ready);
  $(window).on('scroll', function () {
    var fromTop = $(window).scrollTop();

    if ($(window).width() >= 481) {
      setAnimationList();
    }

    $('body').toggleClass("down", fromTop > 150);
  });
})(jQuery);